import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { ServerlessOAuthConfig } from '@stg-js-ngx-core/oauth';
import { MyDietCommonService } from './common/services/mydiet-common.service';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { ServerlessOauthService } from "@stg-js-ngx-core/oauth";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'src/app/common/block-ui';
import { ToastrService } from 'ngx-toastr';
import { CommonModalComponent } from './common/components/common-modal/common-modal.component';
import { AppConfigService } from './appServiceConfig';
import { MyDietRbacCustomService } from './common/services/mydiet-rbac.service';
import { facilityListAPIResponse, facilityListModel } from './common/models/facilitylist.model';
import { CookieService } from 'ngx-cookie-service';
import { appConfigurationModelResponse } from './common/models/appConfiguration.model';
import { DELEGATED_PROVIDER_AUTH_CLIENT_CODE, DELEGATED_PROVIDER_CLIENT_GROUP, DELEGATED_PROVIDER_SECURED_OBJECT_NAMES, DELEGATED_PROVIDER_USER_ROLE } from './common/mydiet-constants';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Default,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    public showPopup: boolean = false;
    public title = 'my-diet-manual-ui-app';
    public appLoad: boolean = true;
    public selfService: boolean = true;
    public logo: string = '/assets/images/Nutrition Manual Across the Continuum of Care Final.png';
    public profileImageUrl: string = '/assets/images/genericAvatar.png';
    public showAuthMsg: boolean = false;
    public showRouter: boolean = false;
    public badgeCount = 0;
    public hidden = true;
    public showFacilitySelector: boolean = false;
    public showChat = false;
    chatPosition = { top: window.innerHeight - 150, left: window.innerWidth - 150 };
    private isDragging = false;
    private dragOffset = { x: 0, y: 0 };
    // public oauthProfile: OauthProfileResponseObject;
    public disableNotificationIconForOtherPages: boolean = true;
    public showMenu: boolean = false;
    public unauthorized: boolean = false;
    private timerLeft: number = 50;
    private autoSaveInterval: any;
    private selfServiceDisbaleSub: Subscription;
    private chatBotSubscription: Subscription;

    @BlockUI() blockUI: NgBlockUI;
    @ViewChild('pageHeader') pageHeader: ElementRef;

    menuItems: any = [];
    menuItemsList: any = [
        { title: 'Home', page: '/home', iconClass: 'fas fa-home', stgSecuredObjectCustom: null },
        { title: 'New User Registration Approvals ', page: '/approvals', iconClass: 'fas fa-user-plus', stgSecuredObjectCustom: 'DIETMANUAL_APPROVALS' },
        { title: 'Administration', page: '/administration', iconClass: 'far fa-cog', stgSecuredObjectCustom: 'DIETMANUAL_ADMINISTRATION' },
        { title: 'Diet Manual', page: '/dietmanuals', iconClass: 'fa fa-sharp fa-regular fa-carrot', stgSecuredObjectCustom: 'DIETMANUAL_MANUAL' },
        { title: 'Patient Education', page: '/userpatienteducation', iconClass: 'fas fa-chalkboard-teacher', stgSecuredObjectCustom: 'DIETMANUAL_PATIENTHANDOUTS' },
        { title: 'Calculations', page: '/calculations', iconClass: 'fa fa-regular fa-calculator', stgSecuredObjectCustom: 'DIETMANUAL_CALCULATIONS' },
        // { title: 'MyNutrition Resources', page: '/mynutritionresources', iconClass: 'fal fa-books', stgSecuredObjectCustom: 'DIETMANUAL_NUTRITIONRESOURCES' },
        
        //this is commented (below line) because this is not part of the current release, but will be added in future releases.
        //{ title: 'Resources', page: '/userresources', iconClass: 'fal fa-books', stgSecuredObjectCustom: 'DIETMANUAL_NUTRITIONRESOURCES' }
    ];

    profileMenuItems: any = [];

    oauthConfig: ServerlessOAuthConfig = {
        serverless: true,
        clientId: this.appConfigService.getConfig().clientId,
        rbacEnabled: true,
        rbacAppName: this.appConfigService.getConfig().rbacAppName,
        revalidateAfterMin: 30,
        sessionExpirationAlertInMin: 3,
        longestTimeToLiveHours: 8,
        autoLogoutOnSessionExpired: true,
        logoutUrl: this.appConfigService.getConfig().baseUrls.logout,
        environmentConfig: this.appConfigService.getConfig()
    };
    path: string;
    prelogin: boolean;
    public loadWithRBAC: boolean = false;
    public facilityList: facilityListModel[] = [];
    public loadWithChatBot: boolean = false;
    public loadChatbotForActive: boolean = false;

    constructor(private commonService: MyDietCommonService, private router: Router, private serverlessOauthService: ServerlessOauthService,
        private modalService: NgbModal,
        private myDietCommonService: MyDietCommonService,
        private toastrService: ToastrService,
        private appConfigService: AppConfigService,
        private customRbacService: MyDietRbacCustomService,
        private cookieService: CookieService,
        private ngZone: NgZone,
        private cdr: ChangeDetectorRef,
        private el: ElementRef) {
        const existingToken = this.cookieService.get('host-token');

        if (window.location.href.indexOf('token') > -1 && window.location.href.indexOf('selfService') === -1) {
            this.selfService = false;
            this.appLoad = true;
            this.unauthorized = false;
            this.blockUI.start();
        }
        else if (existingToken) {
            this.selfService = false;
            this.appLoad = true;
            this.unauthorized = false;
            this.commonService.oAuthToken = existingToken;
            this.blockUI.start();
        }

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                let url = event.urlAfterRedirects;
                let path = url.split('/');
                path = path[1].split('?');
                if (path && path.length) {
                    if (path[0].indexOf('selfService') === -1 && path[0].indexOf('signup') === -1 && path[0].indexOf('unauthorized') === -1) {
                        this.path = '/' + path[0];
                        this.selfService = false;
                        this.appLoad = true;
                        this.prelogin = true;
                    } else {
                        this.prelogin = false;
                    }
                }
            }
        });
    }

    ngOnInit(): void {
        // Seed facility-selector visibility from the current URL in case the initial
        // NavigationEnd already fired before this subscription (e.g. after the oauth
        // APP_INITIALIZER shifted bootstrap timing) and gets missed below.
        this.updateFacilitySelectorVisibility(this.router.url);

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                let url = event.urlAfterRedirects;
                this.path = url;
                // let path = url.split('/');
                // path = path[1].split('?');
                // if (path && path.length) {
                //     this.path = '/' + path[0];
                // }
                // else {
                //     this.path = event.url;
                // }
            }
            if (event.url) {
                this.updateFacilitySelectorVisibility(event.url);
            }
        });

         this.chatBotSubscription = this.commonService.facilityChange
            .subscribe(facility => {
                if (facility && facility.isSubscriptionActive) {
                   this.loadChatbotForActive = true
                }
                else
                    this.loadChatbotForActive = false;
            }
            );


        this.selfServiceDisbaleSub = this.commonService.selfServiceDisable
            .subscribe(isChange => {
                if (isChange) {
                    this.unauthorized = false;
                    this.selfService = false;
                    this.appLoad = true;
                    this.popupMaxInterval(isChange);
                }
            });

        // oauth@22 dropped the (onOauthLoad) output on <app-oauth>; OauthSessionModule.forRoot()
        // already completes the handshake via APP_INITIALIZER before this component initializes,
        // so just read the resulting profile instead of re-running beginServerlessOauthHandling().
        // The oauth library's initializer runs outside NgZone, so force re-entry here or every
        // state change made during loadApp() (and the HTTP calls it kicks off) won't be picked up
        // by change detection until an unrelated DOM event happens to re-enter the zone.
        this.ngZone.run(() => this.loadApp());
    }

    private updateFacilitySelectorVisibility(url: string): void {
        if (url === '/' || url === '/home' || url === '/administration/facility' || url === '/administration/setupsubscription') {
            this.showFacilitySelector = true;
        } else {
            this.showFacilitySelector = false;
            this.disableNotificationIconForOtherPages = true;
        }
    }



    toggleChat() {
        this.showChat = !this.showChat;
        // const agentHolder = this.el.nativeElement.querySelector('.agentHolder');
        // agentHolder.classList.toggle('open');
    }

    loadApp() {
        let allSecuredObjects: any;
        allSecuredObjects = this.serverlessOauthService.getOauthProfile();
        const existingToken = this.cookieService.get('host-token');
        if (!existingToken && !(allSecuredObjects && allSecuredObjects.token) && (window.location.href.indexOf('token') === -1 || window.location.href.indexOf('selfService') > -1)) {
            this.selfService = true;
            this.appLoad = false;
            this.unauthorized = false;
        }
        else {
            this.selfService = false;
            this.appLoad = true;
            this.unauthorized = false;
            this.blockUI.stop();
            if (allSecuredObjects && (allSecuredObjects.token || existingToken)) {
                this.blockUI.start();
                if (!existingToken && allSecuredObjects.token) {
                    const myDate: Date = new Date();
                    myDate.setHours(myDate.getHours() + 6);
                    this.cookieService.set('host-token',
                        allSecuredObjects.token,
                        {
                            expires: new Date(new Date().getTime() + 1000 * 60 * 30),
                            path: '/',
                            secure: true,
                            sameSite: 'Strict'
                        }
                    );
                    this.commonService.oAuthToken = allSecuredObjects.token;
                }
                else if (existingToken && existingToken !== allSecuredObjects.token) {
                    this.commonService.oAuthToken = allSecuredObjects.token;
                }
                else {
                    this.commonService.oAuthToken = existingToken
                }

                this._cleanUrl();
                this.showRouter = true;

                // Delegated provider users (DEL-MyDietManual-Provider) are not part of ADAMS,
                // so the RBAC API will not return any data. Skip the RBAC call and assign a
                // synthetic 'User' role built from the OAuth profile attributes.
                const oauthProfileAttrs = this._getOauthProfileAttributes(allSecuredObjects);
                if (this._isDelegatedProviderUser(oauthProfileAttrs)) {
                    this.customRbacService.rbacCustomObj = this._buildDelegatedProviderRbacProfile(oauthProfileAttrs);
                    this._loadFacilitiesAndContinue();
                } else {
                    this.commonService.getRbacProfileCustom().subscribe({
                        next: (res: any) => {
                            if (res && res.data) {
                                this.customRbacService.rbacCustomObj = res.data;
                                this._loadFacilitiesAndContinue();
                            } else {
                                this.popupMaxInterval(false);
                                this.blockUI.stop();
                                this.toastrService.error('Error: User dont have valid Adams Assignments.');
                            }
                            this.ngZone.run(() => this.cdr.detectChanges());
                        },
                        error: (error: any) => {
                            console.error(error);
                            this.popupMaxInterval(false);
                            this.blockUI.stop();
                            this.toastrService.error('Error occured with ADAMS.Please connect with Administrator.');
                            this.ngZone.run(() => this.cdr.detectChanges());
                        }
                    });
                }
            }
            else {
                this.toastrService.error('Error: User dont have valid Login.Please connect with Administrator.');
                this.popupMaxInterval(false);
            }
        }
    }

   
    // approvalNotification() {
    //     let approveModal = this.modalService.open(CommonModalComponent, {
    //         backdrop: 'static',
    //         keyboard: false,
    //         size: 'md'
    //     });

    //     approveModal.componentInstance.title = 'Pending Approvals';
    //     approveModal.componentInstance.bodyText = 'You have pending facility registrations awaiting your approval.';
    //     approveModal.componentInstance.okText = 'Ok';
    //     approveModal.componentInstance.showCancel = false;
    // }

    getBadgeCount() {
        let userName = this.customRbacService.getUserName();
        this.myDietCommonService.getBadgeCount(userName).subscribe({
            next: (res) => {
                if (res && res.data != null) {
                    this.badgeCount = res.data;
                    this.hidden = this.badgeCount > 0 ? false : true;
                }
            },
            error: (error) => {
                console.error(error);
                this.toastrService.error('Error: Could not get pending approval records count.');
            }
        });
    }

    showNotificationCount() {
        if (this.badgeCount > 0) {
            this.router.navigateByUrl('/approvals');
        }
    }


    startDrag(event: MouseEvent) {
        if ((event.target as HTMLElement).classList.contains('chat-fab')) {
            // Only drag when clicking the image, not the popup
            this.isDragging = true;
            this.dragOffset = {
                x: event.clientX - this.chatPosition.left,
                y: event.clientY - this.chatPosition.top
            };
            document.addEventListener('mousemove', this.onDrag);
            document.addEventListener('mouseup', this.stopDrag);
        }
    }

    onDrag = (event: MouseEvent) => {
        if (this.isDragging) {
            this.chatPosition.left = event.clientX - this.dragOffset.x;
            this.chatPosition.top = event.clientY - this.dragOffset.y;
        }
    };

    stopDrag = () => {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
    };

    ngOnDestroy(): void {
        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval);
        }
        if (this.selfServiceDisbaleSub) {
            this.selfServiceDisbaleSub.unsubscribe();
        }
        if(this.chatBotSubscription)
        {
            this.chatBotSubscription.unsubscribe();
        }
    }

    private getAppConfig() {
        // this.blockUI.start();
        this.commonService.getChatbotstatus().
            subscribe({
                next: (res: appConfigurationModelResponse) => {
                    if (res && Array.isArray(res.data)) {
                        let configList = res.data;
                        this.commonService.appConfigData = res.data;
                        const chatBotStatusConfig = configList.find(config => config.configurationKey === 'ChatBotStatus');
                        if (chatBotStatusConfig && chatBotStatusConfig.configurationValue === '1') {
                            this.loadWithChatBot = true;
                        } else {
                            this.loadWithChatBot = false;
                        }
                    }
                    //  this.blockUI.stop();
                },
                error: (error: any) => {
                    //  this.blockUI.stop();
                    console.error('Error occured while readind app configuration list data:', error);
                }
            });
    }

    private changeHeaderForPreview() {
        if (this.pageHeader) {
            let pageHeading: any = this.pageHeader;
            pageHeading.title = "Diet Manual Preview";
        }
    }

    private loadUnauthorizationPopup(showPopup: any) {
        if (showPopup) {
            let modal = this.modalService.open(CommonModalComponent, {
                keyboard: false,
                backdrop: 'static'
            });
            modal.componentInstance.title = 'Unauthorized';
            modal.componentInstance.bodyText = 'You are not authorized in (MDM)-MyDietManual.';
            modal.componentInstance.okText = 'OK';
            modal.componentInstance.showCancel = false;
            return modal.result.then(() => {
                this.navigateToSelfService();
                return true;
            }).catch(() => {
                this.navigateToSelfService();
                return false;
            });
        } else {
            this.navigateToSelfService();
            return false;
        }
    }

    private navigateToSelfService() {
        this.unauthorized = false;
        this.selfService = true;
        this.appLoad = true;
        this.router.navigate(['/selfService']);
    }

    private popupMaxInterval(reqForLogin: any) {
        clearInterval(this.autoSaveInterval);
        if (!reqForLogin) {
            this.unauthorized = true;
            this.appLoad = false;
            this.cookieService.delete('host-token');
            this.showPopup = true;
            this.router.navigate(['/unauthorized']);
            this.loadUnauthorizationPopup(this.showPopup);
        }
        else {
            this.autoSaveInterval = setInterval(() => {
                this.hidePopup();
            }, 200);
        }

    }

    private hidePopup() {
        if (this.timerLeft > 0) {
            this.timerLeft--;
            if (this.timerLeft === 49) {
                this.showAuthMsg = true;
            }
        } else {
            this.appLoad = false;
            this.timerLeft = 30;
            this.showAuthMsg = false;
            this.showRouter = true;
            this.showPopup = false;
            clearInterval(this.autoSaveInterval);
            this.showAuthMsg = false;
            this.popupMaxInterval(false);
        }
    }

    private trackPageNavigation() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if ((event.url === '/') || (event.url === '/home')) {
                    this.showFacilitySelector = true;
                    if (this.customRbacService.rbacCustomObj?.current_role?.role_name === "System Administrator" || this.customRbacService.rbacCustomObj?.current_role?.role_name == "Facility Administrator") {
                        this.disableNotificationIconForOtherPages = false;
                        this.getBadgeCount();
                    }
                } else if (event.url === '/administration/facility') {
                    this.showFacilitySelector = true;
                } else if (event.url === '/administration/setupsubscription') {
                    this.showFacilitySelector = true;
                }
                else {
                    this.showFacilitySelector = false;
                    this.disableNotificationIconForOtherPages = true;
                }
            }
        });
    }

    private handleFirstTimeNavigation(path: string) {
        if ((path === '/') || (path === '/home')) {
            this.showFacilitySelector = true;
            if (this.customRbacService.rbacCustomObj?.current_role?.role_name === "System Administrator" || this.customRbacService.rbacCustomObj?.current_role?.role_name == "Facility Administrator") {
                this.disableNotificationIconForOtherPages = false;
                this.getBadgeCount();
            }
        } else {
            this.disableNotificationIconForOtherPages = true;
        }
    }

    private _cleanUrl(): void {
        const href = location.origin + location.pathname
            + location.search.replace(/&?token=[^&\$]*/, '')
                .replace(/&$/, '')
                .replace(/^\?$/, '')
                .replace(/&+/g, '&')
                .replace(/\?&/, '?')
                .replace(/\?$/, '')
            + location.hash;
        history.replaceState(null, window.name, href);
    }

    private _loadFacilitiesAndContinue(): void {
        const username = this.customRbacService.rbacCustomObj?.user_name;
        this.commonService.getFacilitiesList(username).subscribe({
            next: (res: facilityListAPIResponse) => {
                const currentRoleName = this.customRbacService.rbacCustomObj?.current_role?.role_name;
                const isPrivilegedRole = currentRoleName === 'System Administrator' || currentRoleName === 'User';
                if (res && res.data && res.data.userDetails && res.data.userDetails.id
                    && ((res.data.costCenters && res.data.costCenters.length > 0) || isPrivilegedRole)
                ) {
                    if (res && res.data && res.data.costCenters.length > 0) { this.facilityList = res.data.costCenters; }
                    else { this.facilityList = []; }
                    this.blockUI.stop();
                    this.loadWithRBAC = true;
                    this.handleFirstTimeNavigation(this.path);
                    this.trackPageNavigation();
                    this.modifyMenu();
                    this.router.navigate([this.path]);
                    if (this.path && this.path.indexOf('preview') > -1) {
                        this.changeHeaderForPreview();
                    }
                    this.loadWithChatBot = false;
                    this.getAppConfig();
                } else {
                    this.popupMaxInterval(false);
                    this.blockUI.stop();
                    this.toastrService.error('Error: Logged user does not mapped with valid Facility;');
                }
                this.ngZone.run(() => this.cdr.detectChanges());
            },
            error: (error: any) => {
                console.error(error);
                this.popupMaxInterval(false);
                this.blockUI.stop();
                this.toastrService.error('Error: Logged user does not mapped with valid Facility;');
                this.ngZone.run(() => this.cdr.detectChanges());
            }
        });
    }

    private _getOauthProfileAttributes(oauthProfile: any): any {
        if (!oauthProfile) { return null; }
        return oauthProfile.attributes
            || oauthProfile?.currentRbacProfile?.full_profile?.attributes
            || oauthProfile?.full_profile?.attributes
            || null;
    }

    private _isDelegatedProviderUser(profileAttrs: any): boolean {
        if (!profileAttrs) { return false; }
        const clientCodeMatches = this._matchesValue(profileAttrs.delegated_auth_client_code, DELEGATED_PROVIDER_AUTH_CLIENT_CODE);
        const clientGroupMatches = this._matchesValue(profileAttrs.client_groups, DELEGATED_PROVIDER_CLIENT_GROUP);
        return clientCodeMatches && clientGroupMatches;
    }

    // client_groups / delegated_auth_client_code may arrive as a string or an array.
    private _matchesValue(source: any, expected: string): boolean {
        const values = Array.isArray(source) ? source : [source];
        return values.some((value: any) => typeof value === 'string' && value.trim().toLowerCase() === expected.toLowerCase());
    }

    private _buildDelegatedProviderRbacProfile(profileAttrs: any): any {
        const attrs = profileAttrs || {};
        const userName = attrs.sAMAccountName || attrs.compass_time_id || attrs.logon_username || attrs.preferred_username || attrs.email || '';
        const firstName = attrs.first_name || attrs.given_name || '';
        const lastName = attrs.last_name || attrs.family_name || '';
        const email = attrs.email || attrs.preferred_username || attrs.verified_primary_email || '';
        const userRole = DELEGATED_PROVIDER_USER_ROLE;
        const userSecuredObjects = DELEGATED_PROVIDER_SECURED_OBJECT_NAMES.map((name, idx) => ({
            object_name: name,
            object_type: 'Tab',
            access_type: 'READ',
            attributes: null,
            attribute: null,
            key_values: null,
            access_control: 'RBAC',
            objectId: `delegated-${idx}`
        }));

        return {
            user_name: userName,
            status: 'A',
            first_name: firstName,
            last_name: lastName,
            email: email,
            guid: attrs.oid || '',
            default_role: userRole,
            current_role: userRole,
            all_roles: [userRole],
            secured_objects: userSecuredObjects
        };
    }

    private modifyMenu() {
        if (this.customRbacService.rbacCustomObj?.secured_objects && this.customRbacService.rbacCustomObj?.secured_objects.length > 0) {
            let securedObj: any = this.customRbacService.rbacCustomObj?.secured_objects?.map(x => x.object_name);
            let roleBasedMenu: any = [];
            this.menuItemsList.forEach((element: any) => {
                if (!element.stgSecuredObjectCustom) {
                    roleBasedMenu.push(element);
                }
                else if (securedObj?.indexOf(element.stgSecuredObjectCustom) > - 1) {
                    roleBasedMenu.push(element);
                }
            });

            this.menuItems = roleBasedMenu;
            this.showMenu = true;
        }

        else {
            this.toastrService.error("Error : User access denied");
            setTimeout(() => {
                window.location.href = this.appConfigService.getConfig().api.uri + "/selfService";
            }, 600);
        }
    }
}
